var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex w-fit items-center shrink-0",style:(_vm.logoStyle),on:{"click":function($event){return _vm.$emit('clicked')}}},[_c('img',{staticClass:"w-[28px] h-[28px]",attrs:{"src":"/countly.png","alt":"Countly Logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }